import { render, staticRenderFns } from "./TermsTH.vue?vue&type=template&id=4d91eb8c&scoped=true&"
import script from "./TermsTH.vue?vue&type=script&lang=js&"
export * from "./TermsTH.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d91eb8c",
  null
  
)

component.options.__file = "TermsTH.vue"
export default component.exports